export const SET_USER_INFO = "SET_USERINFO";
export const SET_DRAWER_VISIBLE = "SET_DRAWER_VISIBLE";
export const SET_INVOICE = "SET_INVOICE";
export const SET_BILLING = "SET_BILLING";
export const SET_DATA_PAYMENT = "SET_DATA_PAYMENT";
export const SET_PLAN_ME = "SET_PLAN_ME";
export const SET_PLANS = "SET_PLANS"

export const setUserInfo = (data) => {
  return {
    type: SET_USER_INFO,
    personal: data,
  };
};

export const setDrawerVisible= (visivle) => {
  return{
    type: SET_DRAWER_VISIBLE,
    visible: visivle
  }
}

export const setInvoice = (invoice) => {
  return{
    type: SET_INVOICE,
    invoice: invoice
  }
}
export const setBilling = (bill) => {
  return{
    type: SET_BILLING,
    bill: bill
  }
}

export const setDataPayment = (payment) => {
  return{
    type: SET_DATA_PAYMENT,
    payment: payment
  }
}

export const setPlanMeAction = (plan) => {
  return {
    type: SET_PLAN_ME,
    plan
  }
}

export const setPlansAction = (plans) => {
  return {
    type: SET_PLANS,
    plans
  }
}